module.exports = __webpack_public_path__ + "media/img/help_center/Institution_Scholarship_Creation_01-fa9b79c2afa16654662774ee529f2414.jpg";